import { WalletsInterface } from './interfaces';

export const walletInitialState: WalletsInterface = {
  wallets: [],
};
